<script lang="ts">
import { computed, defineComponent } from 'vue'
import { useCustomization } from '@/hooks/useCustomization'
import { useEnhancer } from '@/app/enhancer'
import { addWhen } from '@/transforms/object'
import CardHeader from '@/components/ui/card/CardHeader.vue'
import CardItem from '@/components/ui/card/CardItem.vue'
// import isEmpty from 'lodash/isEmpty';

export default defineComponent({
  name: 'GoTemple',
  components: { CardHeader, CardItem },
  emits: ['back'],
  setup(_, { emit }) {
    const customization = useCustomization()
    const { storeFavorites } = useEnhancer()

    const computeStyle = (item: TempleColorType) => [
      {
        height: '120px',
        width: '80px',
        backgroundColor: item.color,
      },
      ...addWhen(item.renderColor, {
        backgroundImage: item.renderColor,
      }),
      ...addWhen(item.renderColor, {
        backgroundImage: `-moz-${item.renderColor}`,
      }),
      ...addWhen(item.renderColor, {
        backgroundImage: `-webkit-${item.renderColor}`,
      }),
    ]

    const templeColors = computed(() => customization.getTempleColors.value)

    const isCurrent = item =>
      item.value === storeFavorites.selectedTemple?.value

    const selected = (item) => {
      if (isCurrent(item))
        return
      storeFavorites.setCurrentConfig('temple', item)
    }
    return {
      templeColors,
      selected,
      isCurrent,
      computeStyle,
      handleClose: () => {
        emit('back')
      },
    }
  },
})
</script>

<template>
  <div class="animate_500">
    <CardHeader
      title="TITANIUM COLOR"
      description="チタンカラー"
      hidden-left
      @close="handleClose"
    />
    <div class="row full-height q-px-md">
      <p class="text-black text-center text-caption full-width q-mb-md q-mt-xs">
        ※色の仕上がりを保証するものではございません。
      </p>
      <q-virtual-scroll
        v-slot="{ item }"
        :items="templeColors"
        virtual-scroll-horizontal
        class="q-pb-sm"
      >
        <CardItem
          :key="item.value"
          :item="item"
          :compute-style="computeStyle(item)"
          icon-class="text-white"
          :is-active="isCurrent(item)"
          @selected="selected(item)"
        />
      </q-virtual-scroll>
    </div>
  </div>
</template>
